import React, { ReactElement } from 'react';

export default function LegalIcon(): ReactElement | null {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="94"
      fill="none"
      viewBox="0 0 108 94"
    >
      <path
        fill="#C2E3FF"
        fillOpacity="0.35"
        d="M67.45 0H40.296C22.917 0 8.83 14.07 8.83 31.424V62.12c0 17.355 14.088 31.424 31.466 31.424h27.156c17.378 0 31.466-14.069 31.466-31.424V31.425C98.917 14.068 84.83 0 67.451 0z"
      ></path>
      <path
        stroke="#B0DBFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 80.769h106"
      ></path>
      <path
        fill="#B0DBFF"
        d="M54.348 68.263c5.355 0 9.974-7.35 12.205-11.024h1.182v11.024H54.348zM54.348 73.775c7.874 0 8.662-5.512 8.662-5.512h11.024v5.512H54.348z"
      ></path>
      <path
        fill="#B0DBFF"
        d="M42.93 80.862c10.08 0 16.536-7.087 16.536-7.087h16.93v7.087H42.93z"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M33.874 68.263H74.03399999999999V73.775H33.874z"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M0 0H44.884V7.087H0z"
        transform="matrix(1 0 0 -1 31.512 80.862)"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M33 15.769L33 19.769"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M75 56.769L75 60.769"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M35 17.769L31 17.769"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M77 58.769L73 58.769"
      ></path>
      <circle cx="27.181" cy="46.608" r="1.181" fill="#0085FF"></circle>
      <circle cx="79.94" cy="21.41" r="1.181" fill="#0085FF"></circle>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M0 0H27.561V11.024H0z"
        transform="matrix(1 0 0 -1 40.174 68.263)"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M0 0H6.3V42.099H0z"
        transform="scale(1 -1) rotate(50 112.071 66.634)"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M42.714 29.691H61.613V45.44H42.714z"
        transform="rotate(-50 42.714 29.69)"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M0 0H4.725V11.024H0z"
        transform="scale(-1 1) rotate(50 -55.726 -32.136)"
      ></path>
      <path
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M0 0H4.725V11.024H0z"
        transform="scale(-1 1) rotate(50 -43.915 -57.466)"
      ></path>
      <path
        fill="#B0DBFF"
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M57.899 11.595H64.199V27.344H57.899z"
        transform="rotate(-50 57.899 11.595)"
      ></path>
      <path
        fill="#B0DBFF"
        stroke="#0085FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M35.629 38.136H41.928999999999995V53.885000000000005H35.629z"
        transform="rotate(-50 35.629 38.136)"
      ></path>
      <circle
        cx="54.266"
        cy="27.563"
        r="3.543"
        stroke="#0085FF"
        strokeWidth="2"
        transform="rotate(-50 54.266 27.563)"
      ></circle>
    </svg>
  );
}
